module.exports = __webpack_public_path__ + "img/ide-event.6d05f41c.svg";